import { useEffect, useRef, useState } from "react";

export default function ScrollFade({ children, className = "", testid, activeKey }) {
  const ref = useRef(null);
  const [fade, setFade] = useState("none");

  const measure = () => {
    const el = ref.current;
    if (!el) return;
    const left = el.scrollLeft > 4;
    const right = el.scrollLeft + el.clientWidth < el.scrollWidth - 4;
    setFade(left && right ? "both" : left ? "left" : right ? "right" : "none");
  };

  useEffect(() => {
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    const el = ref.current;
    const a = el?.querySelector('[data-state="active"]');
    if (!a) return;
    const l = a.getBoundingClientRect().left - el.getBoundingClientRect().left + el.scrollLeft, r = l + a.offsetWidth;
    if (l < el.scrollLeft + 24) el.scrollTo({ left: l - 24, behavior: "smooth" });
    else if (r > el.scrollLeft + el.clientWidth - 24) el.scrollTo({ left: r - el.clientWidth + 24, behavior: "smooth" });
  }, [activeKey]);

  const nudge = (dir) => ref.current?.scrollBy({ left: dir * ref.current.clientWidth * 0.6, behavior: "smooth" });
  const arrow = (dir) => (
    <button type="button" aria-label={dir > 0 ? "Scroll right" : "Scroll left"} onClick={() => nudge(dir)} data-testid={testid ? `${testid}-scroll-${dir > 0 ? "right" : "left"}` : undefined}
      className={`absolute top-1/2 -translate-y-1/2 ${dir > 0 ? "right-0" : "left-0"} z-10 h-7 w-7 rounded-full bg-background/90 backdrop-blur shadow-[0_2px_8px_-2px_rgba(0,0,0,0.25)] inline-flex items-center justify-center text-foreground hover:scale-105 active:scale-95 transition-transform`}>
      <svg viewBox="0 0 16 16" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={dir > 0 ? "M6 3l5 5-5 5" : "M10 3L5 8l5 5"} /></svg>
    </button>
  );
  return (
    <div className="relative min-w-0">
      <div ref={ref} onScroll={measure} data-fade={fade} data-testid={testid} className={`scroll-fade overflow-x-auto no-scrollbar ${className}`}>
        {children}
      </div>
      {(fade === "left" || fade === "both") && arrow(-1)}
      {(fade === "right" || fade === "both") && arrow(1)}
    </div>
  );
}
